import type { FC } from "react";
import {
  formatRelativeTime,
  type DraftSaveStatus,
} from "../hooks/useDraftSaveStatus.js";

interface DraftSaveStatusIndicatorProps {
  status: DraftSaveStatus;
}

/**
 * Displays the current save status for a draft.
 * Shows "Saving changes..." or "Changes saved X ago".
 * Returns null when there are no changes.
 */
export const DraftSaveStatusIndicator: FC<DraftSaveStatusIndicatorProps> = ({
  status,
}) => {
  if (status.type === "no_changes") {
    return null;
  }

  const text =
    status.type === "saving"
      ? "Saving changes..."
      : `Saved ${formatRelativeTime(status.timestamp)}`;

  return <span className="text-xs text-muted-foreground">{text}</span>;
};
